import { createBreakpoints } from "../../packages/breakpoints";

const BREAKPOINTS = {
	mobile: 640,
	tablet: 1000,
	desktop: 1800,
};

export const {
	useMobileBreakpoint,
	useTabletBreakpoint,
	useDesktopBreakpoint,
	useXLDesktopBreakpoint,
	useBreakpointName,
	MobileBreakpoint,
	TabletBreakpoint,
	DesktopBreakpoint,
	XLDesktopBreakpoint,
	mediaQuery,
} = createBreakpoints(BREAKPOINTS);

export const getBreakpoint = (width) => {
	const entries = Object.entries(BREAKPOINTS);
	for (let i in entries) {
		const [bp, v] = entries[i];
		if (width <= v) return bp;
	}
	return "xl-desktop";
};

export default mediaQuery;

export const breakpoint = mediaQuery;
